import { render } from "./MarketingConfigurePage.vue?vue&type=template&id=0449d900&scoped=true"
import script from "./MarketingConfigurePage.vue?vue&type=script&lang=js"
export * from "./MarketingConfigurePage.vue?vue&type=script&lang=js"

import "./MarketingConfigurePage.vue?vue&type=style&index=0&id=0449d900&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0449d900"]])

export default __exports__